<template>
  <div id="httpPolling" :class="connected ? 'connected' : 'disConnected'">
    <!-- 连接状态指示器 -->
  </div>
</template>

<style>
#httpPolling {
  height: 100px !important;
  z-index: 100000;
  position: fixed;
}
.connected {
  color: green;
  height: 100px;
  border-radius: 50%;
  position: fixed;
  right: 0;
  z-index: 100001;
}
.disConnected {
  color: red;
  height: 100px;
  border-radius: 50%;
  position: fixed;
  right: 0;
  z-index: 100001;
}
</style>

<script>
import { ref, reactive, onMounted, onUnmounted, watch } from "vue";
import { createState } from "../store";
import { useRouter } from "vue-router";
import { httpPollingConfig } from "./js/httpConfig.js";

export default {
  name: "httpPolling",
  setup() {
    const router = useRouter();
    const state = reactive(createState);
    const connected = ref(false);
    const projectTopic = ref(location.search.split("=")[1]);

    // 轮询配置
    const pollingConfig = {
      interval: httpPollingConfig.interval,
      baseUrl: httpPollingConfig.baseUrl,
      matchesUrl: httpPollingConfig.matchesUrl,
      filterUrl: httpPollingConfig.filterUrl,
      matchTimer: null,
      projectTimer: null,
      retryCount: 0,
      maxRetries: httpPollingConfig.maxRetries,
    };

    // HTTP 请求函数 - 原始接口（保留用于项目数据）
    const fetchData = async (topic) => {
      try {
        const response = await fetch(
          `${pollingConfig.baseUrl}?topic=${topic}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        connected.value = true;
        pollingConfig.retryCount = 0;
        return data;
      } catch (error) {
        console.error("请求失败:", error);
        connected.value = false;
        pollingConfig.retryCount++;

        if (pollingConfig.retryCount >= pollingConfig.maxRetries) {
          console.error("达到最大重试次数，暂停轮询");
        }
        return null;
      }
    };

    // 新接口1：获取比赛列表（去重）
    const fetchMatches = async (topic) => {
      try {
        const response = await fetch(
          `${pollingConfig.matchesUrl}?topic=${topic}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        connected.value = true;
        pollingConfig.retryCount = 0;
        return data;
      } catch (error) {
        console.error("获取比赛列表失败:", error);
        connected.value = false;
        pollingConfig.retryCount++;

        if (pollingConfig.retryCount >= pollingConfig.maxRetries) {
          console.error("达到最大重试次数，暂停轮询");
        }
        return null;
      }
    };

    // 新接口2：根据 matchId 过滤数据
    const fetchFilter = async (topic, matchId) => {
      try {
        const response = await fetch(
          `${pollingConfig.filterUrl}?topic=${topic}&matchId=${matchId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        connected.value = true;
        pollingConfig.retryCount = 0;
        return data;
      } catch (error) {
        console.error("过滤数据失败:", error);
        connected.value = false;
        pollingConfig.retryCount++;

        if (pollingConfig.retryCount >= pollingConfig.maxRetries) {
          console.error("达到最大重试次数，暂停轮询");
        }
        return null;
      }
    };

    // 处理比赛列表数据（新接口：返回去重后的比赛列表）
    const handleMatchData = (result) => {
      if (!result || !result.data) return;

      try {
        // 新接口返回格式：{ code: 0, message: "Success", data: [{ matchId, matchName }] }
        state.matchesList = result.data; // 保存比赛列表用于下拉选择

        // 如果没有选中的 matchId，默认选中第一个
        if (!state.selectedMatchId && result.data.length > 0) {
          state.selectedMatchId = result.data[0].matchId;
        }

        // 如果有选中的 matchId，加载该比赛的项目数据
        if (state.selectedMatchId) {
          loadMatchProjects(state.selectedMatchId);
        }

        console.log("比赛列表数据已更新:", result.data.length, "场比赛");
      } catch (error) {
        console.error("处理比赛数据失败:", error);
      }
    };

    // 处理单场比赛的项目数据（新接口：根据 matchId 过滤）
    const handleMatchProjects = (result) => {
      if (!result || !result.data) return;

      try {
        // 新接口返回格式：{ code: 0, message: "Success", data: [项目列表] }
        const list = { menuList: result.data };

        state.matchList.value = list;
        state.menuList.value = list.menuList;
        state.menuList.value = getMatchList();
        state.groupList.value = arrMatchGroup();
        state.active =
          state.active === 0 ? state.groupList.value[0] : state.active;
        state.projectList.value = arrMatchProject(state.active);

        console.log("比赛项目数据已更新:", result.data.length, "个项目");
      } catch (error) {
        console.error("处理项目数据失败:", error);
      }
    };

    // 处理项目数据（对应原 projectTopic）
    const handleProjectData = (dataList, currentPath) => {
      if (!dataList) return;

      try {
        let newPath = "";

        // 判断是否比赛结束进入到颁奖界面
        if (dataList.projectInfo.projectScreenType == 5) {
          newPath =
            "/award" +
            `/${dataList.projectInfo.distance}${dataList.projectInfo.projectType}`;
          router.push({
            path: newPath,
            query: { projectTopic: state.projectTopic },
          });
        } else {
          newPath =
            "/ranking" +
            `/${dataList.projectInfo.distance}${dataList.projectInfo.projectType}`;
        }

        state.matchInfo = dataList.matchInfo; // 保存比赛信息
        state.projectInfo = dataList.projectInfo; // 保存项目信息
        state.selectedMatchId = dataList.matchInfo?.matchID; // 存储比赛id

        // 展示路由名
        state.svgComponentName =
          "svg" + dataList.projectInfo.distance + dataList.projectInfo.gunType;

        // 侧滑弹窗展示list
        state.propshowData = filterliveMenuByPrjoect(
          dataList.projectInfo.groupName,
          dataList.projectInfo.matchProjectName,
        );

        // 根据比赛类型进行展示数据拼接
        if (!dataList.dataList && dataList.topList?.length > 0) {
          state.showList.value = dataList.topList;
        } else if (!dataList.topList && dataList.dataList?.length > 0) {
          state.showList.value = dataList.dataList;
        } else {
          state.showList.value = (dataList.topList || []).concat(
            dataList.dataList || [],
          );
        }

        // 当前不在ranking页面跳转到ranking
        if (currentPath.indexOf("ranking") === -1) {
          router.push({
            path: newPath,
            query: { projectTopic: state.projectTopic },
          });
        }

        if (state.topicType) {
          console.log("选择项目的其他阶段");
          router.push({
            path: newPath,
            query: { projectTopic: state.projectTopic },
          });
          state.show = false;
          state.topicType = false;
        }

        console.log("项目数据已更新");
      } catch (error) {
        console.error("处理项目数据失败:", error);
      }
    };

    // 轮询比赛列表（使用新接口 /matches）
    const pollMatchData = async () => {
      const data = await fetchMatches(state.matchTopic);
      if (data) {
        handleMatchData(data);
      }
    };

    // 加载指定比赛的项目数据（使用新接口 /filter）
    const loadMatchProjects = async (matchId) => {
      console.log("加载比赛项目数据, matchId:", matchId);
      const data = await fetchFilter(state.matchTopic, matchId);
      if (data) {
        handleMatchProjects(data);
      }
    };

    // 轮询项目数据
    const pollProjectData = async () => {
      if (!state.projectTopic) return;

      const data = await fetchData(state.projectTopic);
      if (data) {
        handleProjectData(data, router.currentRoute.value.path);
      }
    };

    // 启动比赛列表轮询（只请求一次）
    const loadMatchData = async () => {
      console.log("加载比赛列表数据...");
      await pollMatchData();
    };

    // 启动项目轮询
    const startProjectPolling = (topic) => {
      // 先停止之前的轮询
      stopProjectPolling();

      if (!topic) return;

      console.log("启动项目轮询:", topic);
      state.projectTopic = topic;

      // 立即执行一次
      pollProjectData();

      // 启动项目轮询
      pollingConfig.projectTimer = setInterval(() => {
        pollProjectData();
      }, pollingConfig.interval);
    };

    // 停止项目轮询
    const stopProjectPolling = () => {
      if (pollingConfig.projectTimer) {
        console.log("停止项目轮询");
        clearInterval(pollingConfig.projectTimer);
        pollingConfig.projectTimer = null;
      }
    };

    // 启动轮询（初始化时只加载比赛列表）
    const startPolling = () => {
      console.log("初始化 HTTP 轮询...");

      // 只加载一次比赛列表
      loadMatchData();

      // 如果URL中有项目topic，启动项目轮询
      if (projectTopic.value) {
        startProjectPolling(projectTopic.value);
      }
    };

    // 停止所有轮询
    const stopPolling = () => {
      console.log("停止所有轮询...");
      stopProjectPolling();
    };

    // 页面可见性变化处理
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log("页面隐藏，暂停轮询");
        stopProjectPolling();
      } else {
        console.log("页面显示，恢复轮询");
        if (state.projectTopic) {
          startProjectPolling(state.projectTopic);
        }
      }
    };

    // 监听 state.projectTopic 的变化
    watch(
      () => state.projectTopic,
      (newTopic, oldTopic) => {
        console.log("projectTopic 变化:", oldTopic, "->", newTopic);

        if (newTopic && newTopic !== "") {
          // 有新的 topic，启动轮询
          startProjectPolling(newTopic);
        } else {
          // topic 为空，停止轮询
          stopProjectPolling();
        }
      },
    );

    // 暴露方法给全局使用（保留用于手动刷新比赛列表）
    window.loadMatchData = loadMatchData;
    window.loadMatchProjects = loadMatchProjects;

    // 工具函数：处理select筛选后的数组
    const selectedLiveMenu = () => {
      return (
        state.matchList.value?.menuList?.filter((match) => {
          return match.matchId === state.selectedMatchId;
        }) || []
      );
    };

    // 根据年份获取比赛列表
    const getMatchList = () => {
      let arr = [];
      let arrMatchId = [];
      (state.menuList.value || []).forEach((item) => {
        if (arrMatchId.indexOf(item.matchId) === -1) {
          arrMatchId.push(item.matchId);
          arr.push(item);
        }
      });
      return arr;
    };

    // 获取所有组别
    const arrMatchGroup = () => {
      let arr = [];
      selectedLiveMenu().forEach((item) => {
        if (arr.indexOf(item.matchGroupName) === -1) {
          arr.push(item.matchGroupName);
        }
      });
      return arr;
    };

    // 获取所有项目
    const arrMatchProject = (title) => {
      let arr = [];
      filterliveMenuByGroup(title).forEach((item) => {
        let add = true;
        arr.forEach((arrItem) => {
          if (arrItem[0] === item.projectName) {
            add = false;
          }
        });
        if (add) {
          arr.push([item.projectName, item.topic]);
        }
      });
      return arr;
    };

    // 根据组别筛选比赛
    const filterliveMenuByGroup = (group) => {
      return selectedLiveMenu().filter((item) => {
        return item.matchGroupName === group;
      });
    };

    // 根据组别和项目筛选项目类别
    const filterliveMenuByPrjoect = (group, project) => {
      return filterliveMenuByGroup(group)
        .filter((item) => {
          return item.projectName === project.split("(")[0];
        })
        .sort((a, b) => {
          const aTime = a.startTime.replace(/-/g, "/");
          const bTime = b.startTime.replace(/-/g, "/");
          if (aTime === bTime) {
            if (a.groupNo === "all") {
              return 1;
            } else {
              return -1;
            }
          }
          return new Date(aTime) - new Date(bTime);
        });
    };

    // 生命周期钩子
    onMounted(() => {
      console.log("HTTP 轮询组件已挂载");
      startPolling();

      // 监听页面可见性变化
      document.addEventListener("visibilitychange", handleVisibilityChange);
    });

    onUnmounted(() => {
      console.log("HTTP 轮询组件已卸载");
      stopPolling();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    });

    return {
      connected,
      state,
    };
  },
};
</script>
